/*eslint-disable no-script-url, no-unused-vars*/
/*global daum*/
import React, { Component } from 'react';
import * as Common from '../components/Common';
import { Actions } from '../components/Actions';

class BranchLocationPop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      branchName: '',
      address: '',
      addressDetail: '',
      branchTel: '',
      latitude: 0,
      longitude: 0
    };
  }

  componentDidMount() {
    this._getBranch(this.props.branch_id);
  }

  /**
   * 지점 상세 조회
   * @param {지점 id} branch_id 
   */
  _getBranch(branch_id) {
    Common.callApi('/hp/branch/' + branch_id, 'get', null)
    .then(result => {
      if(result.resultCode === 'success') {
        var resultData = result.resultData;
        this.setState({
          branchName: resultData.branchName,
          address: resultData.address,
          addressDetail: result.addressDetail,
          branchTel: resultData.branchTel,
          latitude: resultData.latitude,
          longitude: resultData.longitude
        });

        window.daum.maps.load(() => {
          var position = new window.daum.maps.LatLng(resultData.latitude, resultData.longitude);
          var container = document.getElementById('map');
          var options = {
            center: position,
            level: 3
          };

          var map = new window.daum.maps.Map(container, options);
          map.addControl(new window.daum.maps.ZoomControl(), window.daum.maps.ControlPosition.RIGHT);

          var marker = new window.daum.maps.Marker({
            position: position,
            map: map
          });
          marker.setMap(map);

          var infowindow = new window.daum.maps.InfoWindow({
            position: position,
            content: '<div style="width: 152px;margin: 5px 0 5px 0;text-align: center;font-size: 14px;color: #888;">' + resultData.branchName + '</div>'
          });
          infowindow.open(map, marker);
        });
      }
    });
  }

  render() {
    return (
      <div className="layer-fullpop" id="loca-pop">	
        <div className="bg"></div>
        <div className="loca-layer-pop">
          <div className="top-title">
            <p className="title">위치보기</p>
            <a href={null} className="pop-close layer-pop-close" data-type="location" onClick={this.props.onClick}><span className="blind">닫기</span></a>
          </div>
          <div className="loca-pop-txt">
            <p className="logo"><span className="blind">TOZ StudyCenter</span></p>
            <p className="btxt">{this.state.branchName}</p>
            <p className="stxt">{this.state.address} {this.state.addressDetail}</p>
            <p className="tel">{this.state.branchTel}</p>
          </div>
          <div id="map" className="loca-pop-map"></div>
        </div>
      </div>
    )
  }
}

export default BranchLocationPop;